import type { ApiSuccess } from '@/lib/api'
import type { AdminLoginResult, LoginCredentials } from '../types'
import { http } from '@/lib/api'

/**
 * Admin authentication (email + password). Mirrors swagger/admin-auth.json.
 *
 * Admin users are those with `tenant_id = null`; they sign in here with email
 * and password only (no SSO / OTP). `POST /admin/auth/login` returns a single
 * signed JWT — there is no refresh token — so the session is established from
 * that one token (see `useLogin`). After login the profile is resolved via
 * `GET /auth/me` to determine scope (a `null` tenant marks the super admin).
 */
export const adminAuthApi = {
  /** `POST /admin/auth/login` — returns a signed JWT + the admin user. */
  login: ({ email, password }: LoginCredentials): Promise<AdminLoginResult> =>
    http
      .post<ApiSuccess<AdminLoginResult>>('/admin/auth/login', { email, password })
      .then((res) => res.data),
}
